import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { Button, Glyphicon } from 'react-bootstrap';

/* import Axios library */
import Axios from 'axios';

//import the loading animation component and the modal component
import LoaderAnimation from '../shared/loaderAnimation';
import RJRModal from '../shared/modal';
import SearchResultsModalContent from './components/searchResultsModalContent/searchResultsModalContent';
import DateSearchRefiner from './components/dateSearchRefiner';

//import the static asset URLs var from the config file
import * as RJRTConfigVars from '../../config';
import BackToSearchButton from './components/backToSearchButton';
import ResultsTable from './components/resultsTable';
import SearchResultsPageDisplay from './components/searchResultsPageDisplay';
import SearchResultsHeader from './components/searchResultsHeader';


// create a component
class SearchResults extends Component {

    constructor(props) {
        super(props);
        //the query string is the form values that the user submitted.  They are formatted into a 
        //special query string for Azure search in the search form component
        let queryString='';
        //set up an array of query URLs.  For most collections, this array will only be one
        //but for "All Collections", we will be searching across multiple URLs
        let queryURLArray = [];

        let resultsTitle = '';

        if (this.props.match.params.formBrand === 'allCollections') {
            resultsTitle = `All Collections Search Results`;
        } else if (this.props.match.params.formBrand === 'courtaction') {
            resultsTitle = `Court Action Search Results`;
        } else {
            resultsTitle = `${this.props.match.params.formBrand.toUpperCase()} Search Results ${this.props.match.params.formType.charAt(0).toUpperCase()}${this.props.match.params.formType.substr(1)}`;
        }        
        
        let refinerType = 'DOCUMENT_DATE';
        if (this.props.match.params.formBrand === 'courtaction') {
            refinerType = 'DATE_OF_RULING';
        }
        else if (this.props.match.params.formType === '4B' || this.props.match.params.formType === '4b') {
            refinerType = 'DEPOSITORY_BOX_NUMBER';
            if (this.props.match.params.formBrand === 'rjr') {
                refinerType = 'DEPOSITORY_BOX';
            }
        }
            
        queryString = this.props.location.state ? this.props.location.state.queryString : '' ;

        if (this.props.match.params.formBrand === 'allCollections') {
            //for the "all collections" formBrand, we need to search through all the keys of the search URL object, get all the public URLs
            //and add them to the array
            Object.keys(RJRTConfigVars.RJRTSearchURLS).forEach((topLevelURLObjectKey) => {
                //loop through the object keys for each object
                let searchURLObject = RJRTConfigVars.RJRTSearchURLS[topLevelURLObjectKey];
                Object.keys(searchURLObject).forEach((secondLevelURLObjectKey) => {
                    if (secondLevelURLObjectKey === 'public') {
                        //only if the key is 'public', then add the value for that key to the queryURL array
                        //we store the collection name (the key of the top level object) which we set as a custom header for the request
                        //this way we get back that custom header so we know what collection the results came from
                        queryURLArray.push({'collection': topLevelURLObjectKey, 'url':RJRTConfigVars.RJRTSearchURLS[topLevelURLObjectKey][secondLevelURLObjectKey]});
                    }
                });
            });
            
        } else {
            //for any single collection, the the search URL is in the object in the config with the form brand and form type as keys of the object. For example:
            //the bw public search URL looks like
            // bw: {
            //     public: 'https://rjrtdocs.search.windows.net/indexes/bwpublic/docs/search?api-version=2016-09-01',
            // }
            //EXCEPTION!!!  Object keys can't start with a number so we store 4B as fourb
            // lorillard: {
            //     fourb: 'https://rjrtdocs.search.windows.net/indexes/bwpublic/docs/search?api-version=2016-09-01',
            // }
            let formTypeKey = this.props.match.params.formType.toLowerCase() === '4b' ? 'fourb' : this.props.match.params.formType;
            queryURLArray.push({'collection': this.props.match.params.formBrand, 'url': RJRTConfigVars.RJRTSearchURLS[this.props.match.params.formBrand][formTypeKey]});
        }

        this.state = {
            formType: this.props.match.params.formType,
            formBrand: this.props.match.params.formBrand,
            queryString: queryString,
            filterString: '',
            queryURLs: queryURLArray, 
            resultData: [],
            pages: -1,
            currentPage:0,
            // for all collections, the page size is 10 * the number of collections you're searching. Otherwise it's 50
            pageSize: this.props.match.params.formBrand === 'allCollections' ? (queryURLArray.length * 10) : 50,
            showModal: false,
            modalData: {},
            modalTitle: '',
            loading: true,
            currentPageStart: 1,
            currentPageEnd: 50,
            totalDocCount:0,
            resultsTitle: resultsTitle, 
            dateRefinerOptions: [],
            errorState: false,
            refinedDate: '',
            refinerType: refinerType,
            export: false
        }

        this.fetchData = this.fetchData.bind(this);
        this.handleTableUpdate = this.handleTableUpdate.bind(this);
        this.handleDateSearchRefinerChange = this.handleDateSearchRefinerChange.bind(this);
        this.handleClearDateRefiner = this.handleClearDateRefiner.bind(this);
        this.handleTableRowClick = this.handleTableRowClick.bind(this);
    }

    handleTableUpdate(state,instance) {
        const currentTableState = state;
        this.setState({
            tableState: currentTableState,
            loading: true}, () => {
            this.fetchData();
        });
    }

    fetchData() {

        //scroll the window to the top so you can see the top of the new search results
        window.scrollTo(0,0);

        //this is our array of calls we will make to Azure search. For everything except "All Collections", the
        //length of this array will be 1. For All Collections, it will be however many collections you have.
        let queryArray = [];

        //set the skip var to handle paging through Azure Search
        //we let the table component tell us what page its on. The pages start at 0
        //so you're going to skip that number * the page size. 
        //so when page=0 (page 1) you're going to skip 0 (0 * 10).  When page=1 (page 2) you're going to skip 10 (1 * 10), etc.
        let numToSkip = this.state.tableState.page * this.state.pageSize; 
        
        //init total doc count...this will be added to each time a request comes back with its total
        let totalDocCount = 0;
        //refinder options that come back from Azure search to populate the dropdowns
        let dateRefinerOptions = this.state.dateRefinerOptions;

        let pageSize = 50;
        if (this.state.export) {
            pageSize = 5000;
        }


        //iterate over the queryURL array building a promise for each one and adding it to another array
        //Axios will call each promise and then a final promise will be resolved when they are all resolved.
        this.state.queryURLs.forEach((queryURLItem) => {  
            let query = this.state.queryString;

            //Fix certain issues with Lorillard Search terms
            if (queryURLItem.collection === 'lorillard' && this.state.formType !== '4B' && this.state.formType !== '4b') {
                query = query.replace("DEPOSITORY_BOX","DEPOSITORY_BOX_NUMBER");
            }
            
            let queryParamsObj = {
                count: true, 
                queryType: 'full', 
                searchMode: 'all', 
                top:pageSize, 
                facets: [this.state.refinerType], 
                skip: numToSkip,
                search: query, 
                filter: this.state.filterString
            };
    
            //state.sorted is an array of columns that are currently being sorted on. If there are items in this array
            //iterate through the array of columns sorted, build an array of strings and then join them with a comma to set the param for Azure Search
            if (this.state.tableState.sorted.length > 0) {
                let sortString = this.state.tableState.sorted.map((item) => {
                    let order = item.desc ? 'desc' : 'asc';
                    return `${item.id} ${order}`
                }).join(',');
    
                queryParamsObj.orderby = sortString;
            }

            queryArray.push(Axios.post(queryURLItem.url, queryParamsObj, {headers: {'collection': queryURLItem.collection, 'api-key': RJRTConfigVars.RJRTSearchAPIKey, 'accept': 'application/json;odata=verbose', 'Content-Type': 'application/json'}})
                .then((response) => {
                //the collection these items come from is in the response.config.headers object
                //since we send that as an additional header
                let itemCollection = response.config.headers.collection;
                //update the total doc count for each collections that gets returned
                totalDocCount += response.data['@odata.count'];

                //we ONLY want to reset the date refiners if we're not performing a filtered search
                //otherwise, the date refiner options become just the value the user selected.  So you can't
                //use the dropdown to select another one. 
                if (this.state.refinedDate === '') {
                    dateRefinerOptions = response.data['@search.facets'][this.state.refinerType];
                }

                //iterate through each result and add the collection it comes from as a property
                //we need to show this in the UI
                const taggedResults = response.data.value.map((item) => {
                    item['COLLECTION'] = itemCollection.toUpperCase();
                    return item; 
                });
                
                return taggedResults;
            }));
        }); 

        //this is for when all the promises are resolved
        Axios.all(queryArray)
        .then(Axios.spread((...results) => {
            //combine all the results into a single array
            const combinedResults = [].concat(...results);

            if (this.state.export) {
                const rowSeperator = '\n';
                let csvString = '';
                
                //build the CSV here. Fields are static
                csvString += "Depository Box, Doc ID Begin, Doc ID End, Alias Begin, Alias End " + rowSeperator;

                combinedResults.forEach((value, index) => {
                    let rowString = (value.DEPOSITORY_BOX_NUMBER || value.DEPOSITORY_BOX) + ',' + value.DOCUMENT_BEGIN + ',' + value.DOCUMENT_END
                        + ',' + (value.ALIAS_BEGIN || '') + ',' + (value.ALIAS_END || '');
                   
                    csvString += rowString + rowSeperator;
                })

                if(navigator.msSaveBlob) { // IE 10+
                    var fileName = "results.csv";
                     var blob = new Blob([csvString], {
                                  "type": "text/csv;charset=utf8;"          
                        });
                    navigator.msSaveBlob(blob, fileName);
                }
                else
                {
                    //Create temporary link to click to trigger the download and then remove it
                    let atag = document.createElement("a");
                    let file = new Blob([csvString], {type: 'text/plain'});
                    atag.href = URL.createObjectURL(file);
                    atag.download = `results.csv`;
                    atag.click();
                    //document.removeChild(atag);    
                }
            }
            else {
                let currentPageEnd = 0;

                //if you come back with less results than the page size just set the end number to the page size
                //the avoids having something like "Documents 1-10 of 6" where it should be "Documents 1-6 of 6"
                if (totalDocCount <= this.state.pageSize) {
                    currentPageEnd = totalDocCount;
                } else {
                    currentPageEnd = ((this.state.tableState.page * this.state.pageSize)) + this.state.pageSize;
                }

                this.setState({
                    resultData: combinedResults,
                    pages: Math.ceil(totalDocCount/this.state.pageSize), 
                    loading: false,
                    totalDocCount: totalDocCount,
                    dateRefinerOptions: dateRefinerOptions,
                    currentPageStart: (this.state.tableState.page * this.state.pageSize) + 1,
                    currentPageEnd: currentPageEnd,
                });
            }
        })).catch((error) => {
            if (this.state.queryURLs.length > 1) {
                //Swallow the error because some fields might return correct results
            }
            else {
                //if any of the search URLs throw an error, the whole thing is treated as an error
                //use a functional component here just for the search results error modal 
                const ModalErrorContent = () => <div><p>The search returned an error</p><p>Please go back and try your search again.</p></div>;

                //only set props and show modal if there's a single match.  
                this.setState({loading: false, errorState: true, modalContent: <ModalErrorContent errorMsg={error.stack} />, modalTitle: 'Error', showModal:true});    
            }         

        });       
    }
    
    handleTableRowClick(rowInfo) {

        //all the data needed for the modal is stored in the row object.original so spread that into the props
        let modalContentComp = <SearchResultsModalContent dataTableRow={rowInfo.original} />;
        //if the title is missing, then set the modal title to the document id start - document id end
        this.setState({
            modalContent: modalContentComp, 
            modalTitle: rowInfo.original.TITLE ? rowInfo.original.TITLE : `${rowInfo.original.DOCUMENT_BEGIN} - ${rowInfo.original.DOCUMENT_END}`, 
            showModal:true
        }); 
    }

    handleToggleModal() {
        this.setState({ 
            showModal: !this.state.showModal
        });
    }

    handleResultsCSVExport() {
        this.setState({
            export: true
        }, this.fetchData);   
    }

    handleDateSearchRefinerChange(event) {
        const dateToRefine = event.target.value;
        const filterString = this.state.refinerType + ` eq '${dateToRefine}'`;

        this.setState({
            filterString: filterString,
            refinedDate: dateToRefine,
            loading: true,
        }, this.fetchData);
    }

    handleClearDateRefiner() {
        this.setState({
            filterString: '',
            refinedDate: '',
            loading: true,
        }, this.fetchData);
    }

    render() {

        return (
            <React.Fragment>
                <SearchResultsHeader>
                    <h1>{this.state.resultsTitle} </h1>
                    <BackToSearchButton formBrand={this.state.formBrand} formType={this.state.formType} />
                    { this.state.totalDocCount > 0 && (this.state.formType === '4B' || this.state.formType === '4b') &&
                        <Button onClick={this.handleResultsCSVExport.bind(this)} bsSize="large" bsStyle="primary">
                            <Glyphicon glyph="download" /><span className="form-searchBtn-text">&nbsp; Export to CSV</span>
                        </Button>
                    }                        
                </SearchResultsHeader>
                {/* wait until you have a doc count before showing the total number (to avoid showing 0 of 0 documents) */}
                { this.state.totalDocCount > 0 &&
                    <SearchResultsPageDisplay currentPageStart={this.state.currentPageStart} currentPageEnd={this.state.currentPageEnd} totalDocCount={this.state.totalDocCount} />
                }

                { this.state.loading && 
                    <LoaderAnimation loadingText="Loading search results..." />
                }

                {/* { only render out the table if there are no errors trying to perform the search} */}
                { this.state.errorState === false &&   
                
                    <React.Fragment>

                        <DateSearchRefiner 
                            formType={this.state.refinerType.replace(/_/g,' ')} 
                            selectedValue={this.state.refinedDate} 
                            refinerOptions={this.state.dateRefinerOptions} 
                            clearHandler={this.handleClearDateRefiner} 
                            changeHandler={this.handleDateSearchRefinerChange} 

                        />

                        <ResultsTable
                            pages={this.state.pages}
                            pageSize={this.state.pageSize}
                            defaultPageSize={this.state.defaultPageSize}
                            fetchDataHandler={this.handleTableUpdate}
                            rowClickHandler={this.handleTableRowClick}
                            resultData={this.state.resultData}
                            formBrand={this.state.formBrand}
                            formType={this.state.formType}
                        />
                        
                    </React.Fragment>
                }

                <RJRModal modalContent={this.state.modalContent}  title={this.state.modalTitle} showModal={this.state.showModal} onCloseRequest={() => this.handleToggleModal()}/>

            </React.Fragment>
            
        );
    }
}

SearchResults.propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
    match: PropTypes.object,
}

export default withRouter(SearchResults);


// WEBPACK FOOTER //
// ./src/components/searchResults/searchResults.js